import type { StyleRules } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => {
  const styles: StyleRules = {
    root: {
      color: '#192542',
      fontSize: 14,
      backgroundColor: 'white',
    },
    head: {
      color: '#192542',
      fontWeight: 'bold',
      backgroundColor: '#ffffff',
    },
    cell: {
      color: '#192542',
      fontSize: 14,
      padding: '4px 24px 4px 24px',
      maxWidth: 450,
    },
    cell2: {
      padding: 0,
      position: 'relative',
      minWidth: 126,
    },
    bt_utm: {
      '&:hover': {
        color: '#009358',
        cursor: 'pointer',
      },
    },
    span: {
      color: '#999999',
    },
    bt_help: {
      color: '#818B9D',
      '&:hover': {
        color: '#192542',
      },
    },
    wrapper: {
      overflowX: 'auto',
      width: '100%',
    },
    bt_approve: {
      fontSize: 14,
      color: theme.palette.grey['400'],
      position: 'absolute',
      top: 0,
      width: '50%',
      height: '100%',
      borderLeft: '1px solid #f3f3f3',
      borderRadius: 0,
      '&:hover': {
        backgroundColor: '#009358',
        color: 'white',
      },
    },
    bt_disapprove: {
      fontSize: 14,
      color: theme.palette.grey['400'],
      position: 'absolute',
      top: 0,
      width: '50%',
      height: '100%',
      borderLeft: '1px solid #f3f3f3',
      borderRadius: 0,
      '&:hover': {
        backgroundColor: '#DC3F53',
        color: 'white',
      },
    },
    highlineRowClass: {
      background: 'rgba(0, 255, 0, 0.08)',
      transition: 'background 0.3s',
    },
    campaignRowClass: {
      transition: 'background 0.3s',
    },
  };

  return styles;
});
